import { useState } from 'react';

import { SmoothGraphics as Graphics } from '@pixi/graphics-smooth';
import { Application } from 'pixi.js';

import { AGraph } from './Graph';

export class AGraphRenderer {
  gfxEdges: Graphics;
  gfxNodes: Graphics;
  gfxNodesCtx: Graphics;
  hoverGfx: Graphics;
  activeGfx: Graphics;
  renderVersion = 0;

  constructor(readonly app: Application, readonly graph: AGraph<any, any>) {
    this.gfxEdges = new Graphics();
    this.gfxNodes = new Graphics();
    this.gfxNodesCtx = new Graphics();
    this.hoverGfx = new Graphics();
    this.activeGfx = new Graphics();
  }

  update() {
    this.renderVersion += 1;
    const stage = this.app.stage as typeof this.app.stage & {
      renderVersion: number;
    };
    stage.renderVersion = this.renderVersion;
    this.gfxEdges.clear();
    this.gfxEdges.removeChildren().forEach(child => child.destroy());
    this.gfxNodes.clear();
    this.gfxNodesCtx.clear();

    this.graph.executeLayout();
    this.app.stage.removeChildren();

    this.app.stage.addChild(this.gfxEdges);
    this.app.stage.addChild(this.gfxNodes);

    this.graph.renderEdges(this.gfxEdges, this.app.stage);
    this.graph.renderNodes(this.gfxNodes, this.app.stage);

    this.graph.renderContext(this.gfxNodesCtx, this.app.stage);
    this.app.stage.addChild(this.gfxNodesCtx);
  }
}
